@if(isLoggedIn) {
<div class="display-4 text-center bg-white" style="padding-top:10%">
    <h1>
        <!-- <div class="text-center">
                <span style="--i:1;" class="fade-in-text">C</span>
                <span style="--i:2;" class="fade-in-text">h</span>
                <span style="--i:3;" class="fade-in-text">o</span>
                <span style="--i:4;" class="fade-in-text">o</span>
                <span style="--i:5;" class="fade-in-text">s</span>
                <span style="--i:6;" class="fade-in-text">e</span>
                <span style="--i:7;" class="fade-in-text">&nbsp;</span>
                <span style="--i:8;" class="fade-in-text">w</span>
                <span style="--i:9;" class="fade-in-text">h</span>
                <span style="--i:10;" class="fade-in-text">i</span>
                <span style="--i:11;" class="fade-in-text">c</span>
                <span style="--i:12;" class="fade-in-text">h</span>
                <span style="--i:13;" class="fade-in-text">&nbsp;</span>
                <span style="--i:14;" class="fade-in-text">s</span>
                <span style="--i:15;" class="fade-in-text">i</span>
                <span style="--i:16;" class="fade-in-text">g</span>
                <span style="--i:17;" class="fade-in-text">n</span>
                <span style="--i:18;" class="fade-in-text">a</span>
                <span style="--i:19;" class="fade-in-text">t</span>
                <span style="--i:20;" class="fade-in-text">u</span>
                <span style="--i:21;" class="fade-in-text">r</span>
                <span style="--i:22;" class="fade-in-text">e</span>
                <span style="--i:23;" class="fade-in-text">&nbsp;</span>
                <span style="--i:24;" class="fade-in-text">t</span>
                <span style="--i:25;" class="fade-in-text">o</span>
                <span style="--i:26;" class="fade-in-text">&nbsp;</span>
                <span style="--i:27;" class="fade-in-text">s</span>
                <span style="--i:28;" class="fade-in-text">t</span>
                <span style="--i:29;" class="fade-in-text">a</span>
                <span style="--i:30;" class="fade-in-text">r</span>
                <span style="--i:31;" class="fade-in-text">t</span>
                <span style="--i:32;" class="fade-in-text">:</span>
            </div> -->
        <div>
            <span
                *ngFor=" let item of languageService.languageConfig.welcomeText.split(''); index as i; trackBy: trackByRandom"
                [style]="'--i:' + (i + 1) + ';'" class="fade-in-text">{{item !== ' ' ? item :'\u00A0'}}</span>
        </div>

    </h1>
    <div class="button-container" style="padding-top:100px;">
        <div class="text-center">
            <a routerLink="/amrize">
                <img class="sigbutton" height="90px" src="../../assets/Amrize_h_rgb.svg">
            </a>
        </div>
    </div>
</div>
} @else {
<div class="container-fluid">

    <div class="jumbotron text-center">
        <h2>
            <div class="text-center">Sorry, you are not authorized</div>
        </h2>
    </div>

</div>
}